import { Box, Tooltip } from '@mui/material';

import { BOOKMARK_NAME_MAX_LENGTH } from '@/constants/movie-types-enum';
import { FC } from 'react';
import { clipText } from '@/logic/helpers/clip-text';

interface BookmarkNameProps {
  name: string;
}

export const BookmarkName: FC<BookmarkNameProps> = ({ name }) => {
  return (
    <Tooltip title={name}>
      <Box component='span'>{clipText(name, BOOKMARK_NAME_MAX_LENGTH)}</Box>
    </Tooltip>
  );
};
